// if($('.cont').find('div.stock_warn').length !== 0)
// 	$('.ajax_add_to_cart').css({ 'background-color': '#D60B52' });



// if($('.cont').hasClass('stock_warn'))
// 	$('.ajax_add_to_cart' ).css({ 'background-color': '#D60B52' });


 // if ($('.ajax_add_to_cart').siblings('.stock_warn')) {
 // 	$('.ajax_add_to_cart').css({ 'background-color': '#D60B52' });
 // }